import { useQuery } from "@tanstack/react-query";

import api from "@/services/api";
import { urlDaFotoPequena } from "@/lib/fotoPequena";

/**
 * A miniatura da foto institucional do próprio usuário (`GET /users/{id}` →
 * `foto_miniatura_url`, desde o passo 27), ou o original (`foto_url`) quando falta.
 *
 * O titular sempre lê a própria foto (`_pode_ver_pii_de` em endpoints/users.py).
 * A URL vem ASSINADA e muda a cada resposta: quem a exibe passa por
 * `useSignedImageUrl`, que congela por caminho. `null` = sem foto ou carregando.
 */
export function useMinhaFoto(userId: string | null | undefined): string | null {
  const { data } = useQuery({
    queryKey: ["users", userId, "foto"],
    queryFn: async () => {
      const r = await api.get(`/users/${userId}`);
      return urlDaFotoPequena(r.data);
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
  return data ?? null;
}
